<template>
	<div class="shadowed">
		<div class="inner-content-title">
			Informações da empresa
		</div>
		<div class="logo-container">
			<div class="row">
				<div class="col-xs-12 col-md-12 col-lg-5">
					<div class="row">
						<div class="col-xs-12 col-lg-12">
							<span style="font-size: 12px;">Logo</span><br/>
							<button class="logo-button" @click="$refs.input.click()">
								<img class="logo-image" v-if="url" :src="url" />
								<span class="loading" v-if="url == false">
									<i class="fa fa-fw fa-circle-notch fa-spin"></i>
								</span>
								<span class="icon" v-if="url != false">
									<i class="fa fa-fw fa-upload"></i>
								</span>
							</button>
							<input ref="input" @change="upload" type="file" style="display: none;" accept="image/*" />
						</div>
					</div>
				</div>
				<div class="col-xs-12 col-md-12 col-lg-7">
					<div class="row">
						<div class="col-xs-12 col-lg-6">
							<FormInput v-model="name" :disabled="'disabled'" label="Nome" icon="fa-building" />
						</div>
						<div class="col-xs-12 col-lg-6">
							<FormInput v-model="document" :disabled="'disabled'" label="CNPJ" icon="fa-id-card" />
						</div>
						<div class="col-xs-12 col-lg-4">
							<FormInput v-model="contact_name" :disabled="'disabled'" label="Contato" icon="fa-user" />
						</div>
						<div class="col-xs-12 col-lg-4">
							<FormInput v-model="contact_email" :disabled="'disabled'" label="Email" icon="fa-envelope" />
						</div>
						<div class="col-xs-12 col-lg-4">
							<FormInput v-model="contact_phone" :disabled="'disabled'" label="Telefone" icon="fa-phone fa-flip-horizontal" />
						</div>
						<div class="col-xs-12 col-lg-12">
							<FormTextarea v-model="address" :disabled="'disabled'" label="Endereço" icon="fa-map" />
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Api from "@/lib/Api";

import FormInput from "@/components/FormInput";
import FormTextarea from "@/components/FormTextarea";

export default {
	name: "ConfigCompany",

	components: {
		FormInput,
		FormTextarea,
	},

	data: function() {
		return {
			url: false,

			name: '...',
			document: '...',
			address: '...',
			contact_name: '...',
			contact_email: '...',
			contact_phone: '...',
			valid_until: '...'
		}
	},

	mounted: function() {
		this.load_company();
		this.load_logo();
	},

	methods: {
		load_company: async function() {
			let result = null;
			try {
				result = await Api.get("config/get-company-info");
			} catch (ex) {
				console.log(ex);
                this.$notification.error("Não foi possível obter as informações.");
                this.loading = false;
                return;
			}

			if (result) {
				if (result.error) {
					if (result.data == "unauthorized") {
						this.$notification.error("Desculpe, sua sessão expirou.");
						setTimeout(() => { 
							Api.logout();
							return;
						}, 2000);
					} else {
						this.$notification.error(result.data);
						return;
					}
				} else {
					this.name = result.data.name;
					this.document = result.data.document.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
					this.address = result.data.address;
					this.contact_name = result.data.contact_name ? result.data.contact_name : this.contact_name;
					this.contact_email = result.data.contact_email ? result.data.contact_email : this.contact_email;
					this.contact_phone = result.data.contact_phone ? this.getPhone(result.data.contact_phone) : this.contact_email;
					this.valid_until = result.data.valid_until;
					return;
				}
			} else {
				this.$notification.error("Não foi possível obter a lista.");
				return;
			}
		},

		load_logo: async function() {
			this.url = false;
			let result = null;
			try {
				result = await Api.blob("config/get-logo?t=" + Date.now());
			} catch (ex) {
				console.log(ex);
                this.$notification.error("Não foi possível obter o logo.");
                return;
			}
			
			if (result) {
				this.url = result;
			}

			return;
		},

		upload: async function() {
			if (this.$refs.input.files.length == 0) return;

			this.url = false;
			let file = this.$refs.input.files[0];

			let result = null;
			try {
				result = await Api.upload("config/send-logo", { file: file });
			} catch (ex) {
				console.log(ex);
                this.$notification.error("Não foi possível enviar o novo logo.");
                return;
			}

			if (result) {
				if (result.error) {
					if (result.data == "unauthorized") {
						this.$notification.error("Desculpe, sua sessão expirou.");
						setTimeout(() => { 
							Api.logout();
							return;
						}, 2000);
					} else {
						this.$notification.error(result.data);
						return;
					}
				} else {
					this.$notification.success("Enviado com sucesso.");
					this.load_logo();
					return;
				}
			} else {
				this.$notification.error("Não foi possível enviar o novo logo.");
                return;
			}
		},

		getPhone: function(phone) {
			if (phone) {
				if (phone.length == 8) {
					return phone.replace(/^(\d{4})(\d{4})/, "$1-$2");
				} else if (phone.length == 9) {
					return phone.replace(/^(\d{5})(\d{4})/, "$1-$2");
				} else if (phone.length == 10) {
					return phone.replace(/^(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
				} else if (phone.length == 11) {
					if (phone[0] == "0") {
						return phone.replace(/^(\d{1})(\d{2})(\d{4})(\d{4})/, "$1 ($2) $3-$4");
					} else {
						return phone.replace(/^(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
					}
				} else if (phone.length == 13) {
					return phone.replace(/^(\d{2})(\d{2})(\d{5})(\d{4})/, "+$1 ($2) $3-$4");
				} else {
					return phone;
				}
			}
		},
	}
}
</script>

<style scoped>
.logo-container {
	width: 100%;
	background-color: #fff;
	padding: 15px;
}

.logo-button {
	min-height: 100px;
	position: relative;
	border: none;
	margin: 0;
	padding: 0;
	border-radius: 8px;
	overflow: hidden;
}

.logo-image {
	max-width: 100%;
}

.logo-button > .icon {
	position: absolute;
	font-size: 40px;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	margin: auto;
	width: 80px;
	height: 80px;
	line-height: 75px;
	text-align: center;
	color: #fff;
	border-radius: 100%;
}

.logo-button > .loading {
	position: absolute;
	font-size: 40px;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	margin: auto;
	width: 80px;
	height: 80px;
	line-height: 80px;
	text-align: center;
	color: #999;
}



.logo-button:hover > .icon {
	background-color: #222;
}

.logo-button .fa-upload {
	display: none;
}

.logo-button:hover .fa-upload {
	display: inline;
}

</style>